var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 0C10.4601 0 10.8332 0.373096 10.8332 0.833333V19.1667C10.8332 19.6269 10.4601 20 9.99984 20C9.5396 20 9.1665 19.6269 9.1665 19.1667V0.833333C9.1665 0.373096 9.5396 0 9.99984 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26485 4.43136C5.96811 3.7281 6.92194 3.33301 7.9165 3.33301H14.1665C14.6267 3.33301 14.9998 3.7061 14.9998 4.16634C14.9998 4.62658 14.6267 4.99967 14.1665 4.99967H7.9165C7.36397 4.99967 6.83407 5.21917 6.44336 5.60987C6.05266 6.00057 5.83317 6.53047 5.83317 7.08301C5.83317 7.63554 6.05266 8.16545 6.44336 8.55615C6.83407 8.94685 7.36397 9.16634 7.9165 9.16634H12.0832C13.0777 9.16634 14.0316 9.56143 14.7348 10.2647C15.4381 10.968 15.8332 11.9218 15.8332 12.9163C15.8332 13.9109 15.4381 14.8647 14.7348 15.568C14.0316 16.2713 13.0777 16.6663 12.0832 16.6663H4.99984C4.5396 16.6663 4.1665 16.2932 4.1665 15.833C4.1665 15.3728 4.5396 14.9997 4.99984 14.9997H12.0832C12.6357 14.9997 13.1656 14.7802 13.5563 14.3895C13.947 13.9988 14.1665 13.4689 14.1665 12.9163C14.1665 12.3638 13.947 11.8339 13.5563 11.4432C13.1656 11.0525 12.6357 10.833 12.0832 10.833H7.9165C6.92194 10.833 5.96811 10.4379 5.26485 9.73466C4.56159 9.0314 4.1665 8.07757 4.1665 7.08301C4.1665 6.08845 4.56159 5.13462 5.26485 4.43136Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.447ccd67477442c1f166cc5083a2531f.svg";
export { ForwardRef as ReactComponent };